<template>
  <div
    v-bind="$attrs"
    :class="{
      [classActive]: inView,
      [classInactive]: !inView,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
import inViewMixin from '../../mixins/in-view'

export default {
  name: 'ClassToggleAnimation',
  mixins: [inViewMixin],
  props: {
    classActive: String,
    classInactive: String,
  }
}
</script>